import { CompleteCaseAssessmentTaskForm } from '../../components/Views/CompleteCaseAssessmentTaskForm';
import { FlowContext } from '../../hooks/useFlowContext';

export function CompleteCaseAssessment(props) {
  return (
    <FlowContext.Provider value={props}>
      <CompleteCaseAssessmentTaskForm flowProps={props} />
    </FlowContext.Provider>
  );
}
